import { render, staticRenderFns } from "./SingleOffer.vue?vue&type=template&id=4695df16&"
import script from "./SingleOffer.vue?vue&type=script&lang=js&"
export * from "./SingleOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports